<template>

</template>

<script>
import { getWxConfig } from '@/api/login'
export default {
  data(){
    return {

    }
  },
  created(){
    // console.log(this.wx)
    this.wxConfigInit()
  },
  methods:{
    // if (!store.state.app.currentUrl) {}
    // store.commit('app/open_new_page', document.URL)
    wxConfigInit(){
      let _this = this;
      // getWxConfig({ url: window.location.href }).then(res=>{
      getWxConfig({ url: this.local('currentUrl'), wxCase: (this.session('wxCase')||1) }).then(res=>{
        // console.log(res)
        const { data } = res;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名
          jsApiList: [
            'onMenuShareTimeline',// 即将废弃
            'onMenuShareAppMessage',// 即将废弃
            'onMenuShareQQ',// 即将废弃
            'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareQZone',
            'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd',
            'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage',
            'translateVoice', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu',
            'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'closeWindow',
            'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'
          ] // 必填，需要使用的JS接口列表
        });
        window.wx.ready(()=>{
          console.log('wx config ok!')
          _this.$emit('wxConfigReady')
        })
      })
    },
  }
}
</script>

<style scoped>

</style>